import { JsonFetchResponse, SuggestionsResponse, useSuggestionsFetch as useSuggestionsFetchCore } from "@xapp/chat-widget-core";
import { useSuggestionsUrl } from "./useSuggestionsUrl";

export function useSuggestionsFetch(search: string, context: readonly string[] | undefined): JsonFetchResponse<SuggestionsResponse> {

    const baseUrl = useSuggestionsUrl();

    return useSuggestionsFetchCore({
        query: search,
        context,
        url: baseUrl
    });
}
